import { SVGProps } from "react";

const CreateTransactionIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25" fill="#FBE290" />
      <path d="M25.087 46.884c11.972 0 21.677-9.706 21.677-21.678 0-11.971-9.705-21.677-21.677-21.677S3.41 13.235 3.41 25.207c0 11.971 9.705 21.677 21.677 21.677" fill="#F9CE46" />
      <path d="M37.29 26.29c-6.771 2.02-9.312 4.505-11.377 11.132-.363 1.164-2.052 1.164-2.415 0-2.065-6.627-4.606-9.112-11.377-11.133-1.195-.357-1.195-2.002 0-2.359 6.771-2.021 9.312-4.506 11.377-11.133.363-1.164 2.052-1.164 2.415 0 2.065 6.627 4.606 9.112 11.377 11.133 1.195.357 1.195 2.003 0 2.36" fill="#fff" />
    </svg>
  );
};

export default CreateTransactionIcon;